import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { ChatModel } from '@models/chat.model'
import { ChatService } from '@app/services'
import MainConfig from '../../../../config/main'

@Component({
    selector: 'app-communication-reaction',
    templateUrl: './communication-reaction.component.html',
    styleUrls: ['./communication-reaction.component.css'],
})
export class CommunicationReactionComponent implements OnInit {
    public enableSetting: boolean
    @Input() isPatient = false
    @Input() chatModel: ChatModel
    @Input() reactIndex = 0
    @Output() _onReact: EventEmitter<number> = new EventEmitter<number>()

    disabled = false

    heartClassName: string = 'hidden'

    constructor(private chatService: ChatService) {
        this.enableSetting = MainConfig.ENABLE_CHAT_REACTION
    }

    ngOnInit() {
        this.disabled = !this.isPatient == !this.chatModel.isPatientCreate
        this.reactIndex = this.chatModel.isPatientCreate ? this.chatModel.clinicReact : this.chatModel.patientReact
        this.heartClassName = this.getClassName()
    }

    getClassName() {
        if (this.disabled) {
            return 'hidden'
        }
        switch (this.reactIndex) {
            case 1:
                return 'fa-heart'
            case 2:
                return 'fa-heart-broken'
            default:
                return 'fa-heart-o'
        }
    }

    changeReact(reactIndex) {
        console.debug('changeReact')
        this.reactIndex = reactIndex
        if (this.isPatient) {
            this.chatModel.patientReact = this.reactIndex
        } else {
            this.chatModel.clinicReact = this.reactIndex
        }
        this.saveReaction()
    }

    saveReaction() {
        this.chatService.updateReaction(this.chatModel._id, {
            clinicReact: this.chatModel.clinicReact || 0,
            patientReact: this.chatModel.patientReact || 0,
        })
    }

}



// WEBPACK FOOTER //
// ./src/app/commons/chat/communication-reaction/communication-reaction.component.ts